<template>
  <v-card>
    <v-card-title>
      <div>
        <v-icon color="primary" @click="backToHome()">mdi-map</v-icon>
        <div class="mt-3"><span class="font-weight-bold">Virus Watch</span></div>
        <div class="">
          source:
          <a href="https://services1.arcgis.com/0MSEUqKaxRlEPj5g/ArcGIS/rest/services/2019_ncov_cases/FeatureServer" target="_blank">ArcGIS</a>
        </div>
        <div class="">Confirmed: {{ dataGetStats.confirmed }}</div>
        <div class="">Deaths: {{ dataGetStats.deaths }}</div>
        <div class="">Recovered: {{ dataGetStats.recovered }}</div>
      </div>
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="table"
      :search="search"
      :loading="dataGetLoading"
      item-key="id"
      class="elevation-1 text-primary"
      :rows-per-page-items="[15, 25]"
      :footer-props="{
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus'
      }"
    >
      <template v-slot:items="props">
        <td class="text-sm-middle font-weight-bold">{{ props.item.countryRegion }}</td>
        <td class="text-sm-middle">{{ props.item.provinceState }}</td>
        <td class="text-sm-middle">{{ props.item.lastUpdate }}</td>
        <td class="text-sm-middle">{{ props.item.confirmed }}</td>
        <td class="text-sm-middle">{{ props.item.deaths }}</td>
        <td class="text-sm-middle">{{ props.item.recovered }}</td>
        <td class="text-sm-middle">{{ props.item.lat }}</td>
        <td class="text-sm-middle">{{ props.item.lng }}</td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Table',
  data() {
    return {
      search: '',
      headers: [
        {
          text: 'Country/Region',
          align: 'start',
          sortable: true,
          value: 'countryRegion'
        },
        {
          text: 'Province/State',
          align: 'start',
          sortable: true,
          value: 'provinceState'
        },
        {
          text: 'Last Updated',
          align: 'start',
          sortable: false,
          value: 'lastUpdate'
        },
        {
          text: 'Confirmed',
          align: 'center',
          sortable: false,
          value: 'confirmed'
        },
        {
          text: 'Deaths',
          align: 'center',
          sortable: false,
          value: 'deaths'
        },
        {
          text: 'Recovered',
          align: 'center',
          sortable: false,
          value: 'recovered'
        },
        {
          text: 'Latitude',
          align: 'center',
          sortable: false,
          value: 'lat'
        },
        {
          text: 'Longitude',
          align: 'center',
          sortable: false,
          value: 'lng'
        }
      ]
    };
  },
  computed: {
    ...mapGetters({
      dataGetData: 'dataGetData',
      dataGetStats: 'dataGetStats',
      dataGetLoading: 'dataGetLoading'
    }),
    table() {
      return this.dataGetData;
    }
  },
  methods: {
    backToHome() {
      this.$router.push('/');
    }
  }
};
</script>

<style scoped></style>
